import Resource from '@/api/core/resource'
import appConfig from '@/config/appConfig'

class Paciente extends Resource {
  constructor () {
    super('pacientes')
  }

  verificarExistencia (data) {
    return this.request.post(this.uri.concat('/verificar-existencia'), data)
  }

  verificarExistenciaAgenda (data) {
    return this.request.post(this.uri.concat('/verificar-existencia-agenda'), data)
  }

  obtenerTratamientos (pacienteId, data) {
    return this.request.post(
      this.uri
        .concat('/')
        .concat(pacienteId)
        .concat('/tratamientos'),
      data
    )
  }

  obtenerTratamiento (pacienteId, prestacionId) {
    return this.request.get(
      this.uri
        .concat('/')
        .concat(pacienteId)
        .concat('/tratamientos/')
        .concat(prestacionId)
    )
  }

  altaTratamiento (pacienteId, data) {
    return this.request.post(
      this.uri
        .concat('/')
        .concat(pacienteId)
        .concat('/tratamientos/alta'),
      data
    )
  }

  actualizarSeccionTratamiento (pacienteId, tratamientoId, datos) {
    return this.request.put(
      this.uri
        .concat('/')
        .concat(pacienteId)
        .concat('/tratamientos/')
        .concat(tratamientoId),
      datos
    )
  }

  guardarAtencionMedicacion (pacienteId, data) {
    return this.request.put(
      this.uri
        .concat('/')
        .concat(pacienteId)
        .concat('/atencion_medicacion'),
      data
    )
  }

  obtenerHistoriaClinica (pacienteId, data) {
    return this.request.post(
      this.uri
        .concat('/')
        .concat(pacienteId)
        .concat('/historia_clinica'), data
    )
  }

  obtenerDetalleHistoriaClinica (pacienteId, Id, data) {
    return this.request.post(
      this.uri
        .concat('/')
        .concat(pacienteId)
        .concat('/')
        .concat(Id)
        .concat('/historia_clinica_detalle'), data
    )
  }

  guardarHistoriaClinica (pacienteId, data) {
    return this.request.put(
      this.uri
        .concat('/')
        .concat(pacienteId)
        .concat('/historia_clinica'),
      data
    )
  }

  actualizarHistoriaClinica (pacienteId, data) {
    return this.request.put(
      this.uri
        .concat('/')
        .concat(pacienteId)
        .concat('/historia_clinica'),
      data
    )
  }

  obtenerObrasSociales (pacienteId) {
    return this.request.get(
      this.uri
        .concat('/')
        .concat(pacienteId)
        .concat('/obras-sociales')
    )
  }

  obtenerHistoriaClinicaFicha (pacienteId) {
    window.open(
      appConfig.urlServer.concat(
        this.uri
          .concat('/')
          .concat(pacienteId)
          .concat('/historia_clinica_ficha')
      )
    )
  }

  obtenerRecetas (pacienteId) {
    return this.request.get(
      this.uri
        .concat('/')
        .concat(pacienteId)
        .concat('/recetas')
    )
  }

  guardarRecetas (pacienteId, data) {
    return this.request.put(
      this.uri
        .concat('/')
        .concat(pacienteId)
        .concat('/recetas'),
      data
    )
  }

  obtenerUrlSubirArchivo (data) {
    return appConfig.urlApi.concat(
      this.uri
        .concat('/subir-receta')
    )
  }

  eliminarReceta (id) {
    return this.request.delete(
      this.uri
        .concat('/')
        .concat(id)
        .concat('/recetas')
    )
  }

  obtenerObservaciones (pacienteId) {
    return this.request.get(
      this.uri
        .concat('/')
        .concat(pacienteId)
        .concat('/observaciones')
    )
  }

  obtenerObservacion (pacienteId, id) {
    return this.request.get(
      this.uri
        .concat('/')
        .concat(pacienteId)
        .concat('/observaciones/')
        .concat(id)
    )
  }

  guardarObservaciones (pacienteId, data) {
    return this.request.put(
      this.uri
        .concat('/')
        .concat(pacienteId)
        .concat('/observaciones'),
      data
    )
  }

  eliminarObservacion (id) {
    return this.request.delete(
      this.uri
        .concat('/')
        .concat(id)
        .concat('/observaciones')
    )
  }

  guardarAntecedentes (pacienteId, data) {
    return this.request.post(
      this.uri
        .concat('/')
        .concat(pacienteId)
        .concat('/antecedentes'),
      data
    )
  }

  obtenerAntecedentes (pacienteId) {
    return this.request.get(
      this.uri
        .concat('/')
        .concat(pacienteId)
        .concat('/antecedentes')
    )
  }

  descargaReceta (archivoId) {
    window.open(
      appConfig.urlServer.concat(
        this.uri
          .concat('/')
          .concat(archivoId)
          .concat('/receta/descargar')
      )
    )
  }

  obtenerAranceles (pacienteId) {
    return this.request.get(
      this.uri
        .concat('/')
        .concat(pacienteId)
        .concat('/aranceles')
    )
  }
}

export default new Paciente()
